var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3866 4.1875V6.00212",
    stroke: "#000000",
    strokeWidth: 1.34971,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3866 14.3203V15.838",
    stroke: "#000000",
    strokeWidth: 1.34971,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3866 11.74V8.125",
    stroke: "#000000",
    strokeWidth: 1.34971,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0279 15.9975C16.3941 15.9975 17.5007 14.9046 17.5007 13.5553V11.6114C16.5967 11.6114 15.8686 10.8923 15.8686 9.9995C15.8686 9.10668 16.5967 8.38687 17.5007 8.38687L17.5 6.44212C17.5 5.09285 16.3926 4 15.0271 4H4.97757C3.61209 4 2.50469 5.09285 2.50469 6.44212L2.50391 8.4502C3.40797 8.4502 4.13607 9.10668 4.13607 9.9995C4.13607 10.8923 3.40797 11.6114 2.50391 11.6114V13.5553C2.50391 14.9046 3.61052 15.9975 4.97679 15.9975H15.0279Z",
    stroke: "#000000",
    strokeWidth: 1.34971,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationsIcon);
export default __webpack_public_path__ + "static/media/reservationsIcon.4d1e87296e923e24fd981a99cb3e5f26.svg";
export { ForwardRef as ReactComponent };